(function (jedeye) {
    "use strict";
    jedeye(window.jQuery, window, document);
}(function ($, window, document) {

    // Contains all methods added for the requested for the current page instance
    window.JedeyeInstance = {};

    $(window).on('ajaxUpdateComplete', function (event, context, data) {

        /**
         * Trigger custom alerts.
         */
        if (data.hasOwnProperty('alert')) {
            $(document).trigger("jedeye.showModalPopup", [data.alert.message, data.alert.title, data.alert.subtitle, data.alert.iconClass]);
        }

        // Manages modal triggering or dismissing from the server side responses
        if (data.hasOwnProperty('triggerModal')) {
            $(data.triggerModal).modal('show');
        } else {
            if (data.hasOwnProperty('dismissModal')) {
                $(data.dismissModal).modal('hide');
            }
        }

        /**
         * Handle specific AJAX responses.
         */
        if (context.hasOwnProperty('handler')) {
            if (context.handler == 'reservation::onExtraItemUpdate') {

                $('[data-toggle="popover"]:not([data-event-attached])').each(function () {
                    $(this).popover({
                        placement: 'auto'
                    });
                    $(this).attr('data-event-attached', '');
                });
            }

            if (context.handler == 'reservation::onPackItemToggle') {

                $('.extras-table:first').each(function () {
                    var $table = $(this);
                    var $buttonContainers = $('tfoot .btn-container', $table);
                    $buttonContainers.eq(data._index).each(function () {
                        var index = $(this).index();
                        $('td, th', $table).removeClass('active');
                        if (data._action == 'add') {
                            $('tr', $table).each(function () {
                                $(this).children().eq(index).addClass('active');
                            });
                            $buttonContainers.not(':eq(' + data._index + ')').find('button').prop('disabled', false);
                            if ($buttonContainers.eq(data._index).hasClass('free-item')) {
                                $('button', $(this)).prop('disabled', true);
                            }
                        } else if (data._action == 'remove') {
                            $buttonContainers.find('button').prop('disabled', false);
                            // Activate a free item if available
                            var $freeItem = $table.find('td.free-item:first');
                            if ($freeItem.length) {
                                $('tr', $table).each(function () {
                                    $(this).children().eq($freeItem.index()).addClass('active');
                                });
                                $freeItem.find('button').prop('disabled', true);
                            }

                        }
                    });
                });
            }
        }
    });

    // Scrolls up on form validation error
    $('form[data-request]').on('ajaxError', function (event, obj, context, status) {
        var $el = $(this);
        setTimeout(function () {
            var $errorElems = $el.find('.has-error:first');
            if ($errorElems.length > 0) {
                $('html, body').animate({scrollTop: $errorElems.offset().top - 100}, 800);
            }
        }, 500);
    });

    // Enables form requests to be triggered by elements placed outside of it
    $('[data-request-target-elem]').on('click', function () {
        $($(this).data('request-target-elem')).submit();
    });

    $.fn.parallax = function () {
        var window_width = $(window).width();
        // Parallax Scripts
        return this.each(function(i) {
            var $this = $(this);
            $this.addClass('parallax');

            function updateParallax(initial) {
                var container_height;
                if (window_width < 601) {
                    container_height = ($this.height() > 0) ? $this.height() : $this.children("img").height();
                }
                else {
                    container_height = ($this.height() > 0) ? $this.height() : 500;
                }
                var $img = $this.children("img").first();
                var img_height = $img.height();
                var parallax_dist = img_height - container_height + 100;
                var bottom = $this.offset().top + container_height;
                var top = $this.offset().top;
                var scrollTop = $(window).scrollTop();
                var windowHeight = window.innerHeight;
                var windowBottom = scrollTop + windowHeight;
                var percentScrolled = (windowBottom - top) / (container_height + windowHeight);
                var parallax = Math.round((parallax_dist * percentScrolled));

                if (initial) {
                    $img.css('display', 'block');
                }
                if ((bottom > scrollTop) && (top < (scrollTop + windowHeight))) {
                    $img.css('transform', "translate3D(-50%," + parallax + "px, 0)");
                }

            }

            // Wait for image load
            $this.children("img").one("load", function() {
                updateParallax(true);
            }).each(function() {
                if(this.complete) $(this).load();
            });

            $(document).ready(function () {
                updateParallax(false);
            });

            $(window).scroll(function() {
                window_width = $(window).width();
                updateParallax(false);
            });

            $(window).resize(function() {
                window_width = $(window).width();
                updateParallax(false);
            });
        });
    };

    /*************
     * Routed Functions
     */
    $(document).router({
        // Fleet pages


        dom_group_info: function () {
            window._showGroupInfo = function (triggerEL) {
                var groupId = $(triggerEL).data('id'),
                    $modal = $('#fgmodal-' + groupId);
                $modal.modal({
                    backdrop: true
                });
                $modal.modal('show');
                $modal.find('.fg-booking-btn').off('click').on('click', function () {
                    $modal.modal('hide').data('bs.modal', null);
                    setTimeout(function () {
                        $('button[data-group-id=' + groupId + ']').trigger('click')
                    }, 500)
                });

                var $swiperEl = $('.swiper-container', '#fgmodal-' + groupId);
                if (!$swiperEl.hasClass('swiper-loaded')) {
                    var swiper = new Swiper($swiperEl[0], {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        autoplay: 5000,
                        grabCursor: true,
                        pagination: '#fgmodal-' + groupId + ' .swiper-pagination',
                        paginationClickable: true
                    });
                }

                $swiperEl.addClass('swiper-loaded');
            };

            // Stop href="#hashtarget" links jumping around the page
            var hashLinks = document.querySelectorAll(".fg-tabs a[href^='#']");
            [].forEach.call(hashLinks, function (link) {
                link.addEventListener("click", function (event) {
                    event.preventDefault();
                    $(link).parent().find($(link).attr('href')).addClass('active').siblings('div').removeClass('active');
                    $(link).addClass('active').siblings('a').removeClass('active');
                });
            });
        },

        dom_stations_maps: function () {

            var nl2br = function (str, is_xhtml) {
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            };

            $(function () {

                var reloadMapProperties = function (mapInstance, stationElem) {
                    mapInstance.removeMarkers();
                    mapInstance.addMarker({
                        lat: parseFloat(stationElem.data('lat')),
                        lng: parseFloat(stationElem.data('lng')),
                        title: stationElem.data('title'),
                    });
                    mapInstance.setCenter(stationElem.data('lat'), stationElem.data('lng'));
                    mapInstance.refresh();
                };

                $('.station-info').each(function () {
                    var $stationPopup = $(this),
                        $stationElem = $('.station-info-data', $stationPopup),
                        defaultIcon = $('.pre-icon', $stationPopup).data('default-img');

                    if ($stationElem.length > 0) {

                        $('.contact-us-btn', $stationElem).on('click', function () {
                            if ($(this).data('target-url')) {
                                window.location = $(this).data('target-url');
                            } else {
                                $('html, body').animate({scrollTop: $('form:first').length > 0 ? $('form:first').parent().offset().top - 100 : 0}, 800, function () {
                                    $('form:first input:first').trigger('focus');
                                });
                            }
                        });

                        $('.stations-list .btn-trigger').off("click").on("click", function () {
                            // Load data
                            var $dataEl = $(this).closest('li'),
                                data = $dataEl.data('info'),
                                name = $dataEl.data('name'),
                                group = $dataEl.data('group');

                            $('.st-title', $stationElem).html(data.title).parent().attr('style', !data.title ? 'display: none' : '');
                            $('.st-observations', $stationElem).html(data.observations).parent().attr('style', !data.title ? 'display: none' : '');
                            $('.st-address', $stationElem).html(data.address).parent().attr('style', !data.address ? 'display: none' : '');
                            $('.st-phone-1', $stationElem).html(data.phone_1).parent().attr('style', !data.phone_1 ? 'display: none' : '');
                            $('.st-phone-2', $stationElem).html(data.phone_2).parent().attr('style', !data.phone_2 ? 'display: none' : '');
                            $('.st-email', $stationElem).html(data.email).parent().attr('style', !data.email ? 'display: none' : '');
                            $('.st-schedule-open', $stationElem).html(data.working_days).parent().attr('style', !data.working_days ? 'display: none' : '');
                            $('.st-schedule-closed-inner', $stationElem).html(data.non_working_days).parent().attr('style', !data.non_working_days ? 'display: none' : '');

                            if ($dataEl.data('lat') != '' && $dataEl.data('lng') != '') {
                                $stationElem.data('lat', $dataEl.data('lat'));
                                $stationElem.data('lng', $dataEl.data('lng'));
                            } else {
                                $stationElem.data('lat', 0);
                                $stationElem.data('lng', 0);
                            }

                            $stationElem.data('title', name);

                            $stationPopup.removeClass('animate-in animate-out').addClass('animate-in').show();

                            var minSize = $('.top-side > div:eq(1)', $stationPopup).outerHeight();
                            if (minSize < 298) {
                                minSize = 298;
                            }
                            setTimeout(function () {
                                $('.top-side > div:eq(0)', $stationPopup).css('height', minSize + 'px');
                            }, 100);

                            // Update .station-info-data from server and then reload map properties
                            reloadMapProperties(map, $stationElem);
                            if ($stationPopup.data('loaded') != true) {
                                setTimeout(function () {
                                    reloadMapProperties(map, $stationElem);
                                    reloadMapProperties(map, $stationElem);
                                    $stationPopup.data('loaded', true);
                                }, 150);
                            }
                        });

                        var map = new GMaps({
                            div: '.map',
                            lat: 41.01369,
                            lng: -8.4093757,
                            enableNewStyle: true,
                            fullscreenControl: false,
                            zoom: 12
                        });

                        $(this).on('click', '.close-icon', function () {
                            $stationPopup.hide();
                        });
                    }
                });
            });
        },

        dom_custom_tabs: function () {
            $(".tab-menu a").click(function (e) {
                e.preventDefault();
                var $parent = $(this).closest('.tab-menu-container');

                var tab = $(this).attr("href");
                $(".tab-menu-content", $parent).not(tab).css("display", "none");
                $(tab).fadeIn();
                $(this).addClass("active");
                $(this).siblings().removeClass("active");
            });
        },

        dom_custom_select: function () {
            // Select2
            $(".custom-select").each(function () {
                var $el = $(this);
                $el.select2({
                    minimumResultsForSearch: -1,
                    placeholder: $el.data('placeholder') !== undefined ? $el.data('placeholder') : false
                })
            });
        },

        dom_stretch_image: function() {
            var position = '.stm-stretch-image-right';

            if($(position).length) {
                var windowW = $(document).width();
                var containerW = $('.header-main .container').width();

                var marginW = (windowW - containerW) / 2;

                $(position + ' .vc_column-inner').css({
                    'margin-right' : '-' + marginW + 'px'
                });
            }

            position = '.stm-stretch-image-left';

            if($(position).length) {
                var windowW = $(document).width();
                var containerW = $('.header-main .container').width();

                var marginW = (windowW - containerW) / 2;

                $(position + ' .vc_column-inner').css({
                    'margin-left' : '-' + marginW + 'px'
                });
            }
        },

        // Shared code
        common: function () {

            // Select2

            //Default plugins
            $("select:not(.hide)").each(function () {
                $(this).select2({
                    width: '100%',
                    minimumResultsForSearch: Infinity
                });
            });

            $("select:not(.hide)").on("select2:open", function() {
                var stmClass = $(this).data('class');
                $('.select2-dropdown--below').parent().addClass(stmClass);

                window.scrollTo(0, $(window).scrollTop() + 1);
                window.scrollTo(0, $(window).scrollTop() - 1);
            });

            var uniform_selectors = ':checkbox:not("#createaccount"),' +
                ':radio:not(".input-radio")';

            $(uniform_selectors).uniform({});

            $('.stm-date-timepicker').stm_datetimepicker({minDate: 0, lang: stm_lang_code});

            $('.stm-years-datepicker').stm_datetimepicker({
                timepicker:false,
                format: 'd/m/Y',
                lang: stm_lang_code
            });

            $('img.lazy').lazyload({
                effect: "fadeIn",
                failure_limit: Math.max('img'.length - 1, 0)
            });

            $('[data-toggle="tooltip"]').tooltip();

            $('.listing-menu-mobile > li.menu-item-has-children > a').append('<span class="stm_frst_lvl_trigger"></span>');
            $('body').on('click', '.stm_frst_lvl_trigger', function(e){
                e.preventDefault();
                $(this).closest('li').find('ul.sub-menu').slideToggle();
                $(this).toggleClass('active');
            })

            $('.stm-menu-trigger').click(function(){

                $('.lOffer-account').removeClass('active');
                $('.stm-user-mobile-info-wrapper').removeClass('active');

                $('.stm-opened-menu-listing').toggleClass('opened');
                $('.stm-opened-menu-magazine').toggleClass('opened');
                $(this).toggleClass('opened');
            });

            // Parallax
            function stmFullwidthWithParallax() {

                var screenWidth = $(window).width();
                if(screenWidth < 1140) {
                    var defaultWidth = screenWidth - 30;
                } else {
                    var defaultWidth = 1140 - 30;
                }
                var marginLeft = (screenWidth - defaultWidth) / 2;

                if($('body').hasClass('rtl')) {
                    $('.stm-fullwidth-with-parallax').css({
                        'position' : 'relative',
                        'left': (marginLeft - 15) + 'px'
                    })
                }

                $('.stm-fullwidth-with-parallax').css({
                    'width': screenWidth + 'px',
                    'margin-left': '-' + marginLeft + 'px',
                    'padding-left': (marginLeft - 15) + 'px',
                    'padding-right': (marginLeft - 15) + 'px'
                })
            }

            if($('.stm-simple-parallax').length) {
                $('.stm-simple-parallax').append('<div class="stm-simple-parallax-gradient"><div class="stm-simple-parallax-vertical"></div></div>');
                jQuery(window).scroll(function(){
                    var currentScrollPos = $(window).scrollTop();
                    var scrollOn = 400 - parseFloat(currentScrollPos/1.2);
                    if(scrollOn < -200) {
                        scrollOn = -200;
                    }
                    $('.stm-simple-parallax').css('background-position', '0 ' + scrollOn + 'px');
                });
            }

            $('.stm-material-parallax').parallax();

            stmFullwidthWithParallax();

            function showModalPopup(message, title, subtitle, iconClass) {
                title = title || '';
                subtitle = subtitle || '';
                message = message || '';
                iconClass = iconClass || '';
                var $modal = $('#appModal:first');
                $('.m-title', $modal).html(title);
                $('.m-subtitle', $modal).html(subtitle);
                $('.m-message', $modal).html(message);
                // $('#appModalIcon', $modal).removeClass().addClass('icon').addClass(iconClass);
                $modal.modal('show');
            }

            $(document).on('jedeye.showModalPopup', function (event, message, title, subtitle, iconClass) {
                showModalPopup(message, title, subtitle, iconClass);
            });

            // code put inside the common property will be executed on all page loads
            function centerModal() {
                $(this).css('display', 'block');
                var $dialog = $(this).find(".modal-dialog"),
                    offset = ($(window).height() - $dialog.height()) / 2,
                    bottomMargin = parseInt($dialog.css('marginBottom'), 10);

                // Make sure you don't hide the top part of the modal w/ a negative margin if it's longer than the screen height, and keep the margin equal to the bottom margin of the modal
                if (offset < bottomMargin) offset = bottomMargin;
                $dialog.css("margin-top", offset);
            }

            $(document).on('show.bs.modal', '.modal', centerModal);
            $(window).on("resize", function () {
                $('.modal:visible').each(centerModal);
            });

            // Backdrop z-index fix
            // This solution uses a setTimeout because the .modal-backdrop isn't created when the event show.bs.modal is triggered.
            $(document).on('show.bs.modal', '.modal', function () {
                var zIndex = 1040 + (10 * $('.modal:visible').length);
                $(this).css('z-index', zIndex);
                setTimeout(function () {
                    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                }, 0);
            });

            // Scrollbar fix
            // If you have a modal on your page that exceeds the browser height, then you can't scroll in it when closing an second modal.
            $(document).on('hidden.bs.modal', '.modal', function () {
                $('.modal:visible').length && $(document.body).addClass('modal-open');
            });

            /********************************************
             * Footer Alignement to Bottom
             */
            function footerAlign() {
                var $footer = $('footer:first');
                var docHeight = $(window).height();
                var footerHeight = $footer.outerHeight();
                var footerTop = $footer.position().top + footerHeight;

                if (footerTop < docHeight) {
                    $footer.css('margin-top', 0 + (docHeight - footerTop) + 'px');
                }
            }

            $(document).ready(function () {
                footerAlign();
            });
            $(window).resize(function () {
                footerAlign();
            });

            // Add bootstrap style to static page tables
            $('table', '.static-page').addClass('table');
        }
    }, true, false);

}));